import React from "react";
import styles from "./Tab.module.css";
import type { tabsProps } from "./types.props";

const Tabs: React.FC<tabsProps> = ({
    items,
    activeKey,
    className = "",
    onTabChange,
    ...props
}) => {
    return (
        <div className={`${styles["tabs-container"]} ${className}`}>
            {items.map((item) => (
                <button
                    key={item.key}
                    className={`${styles["tab-button"]} ${activeKey === item.key ? styles["active"] : ""}`}
                    onClick={() => !item.disabled && onTabChange(item.key)}
                    role="tab"
                    aria-selected={activeKey === item.key}
                    {...props}
                >
                    {item.label}
                </button>
            ))}
        </div>
    );
};

export default Tabs;
